import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { asArray } from '@olivierpascal/helpers';
import { useStyles } from '../../hooks/useStyles';
import { ListItem } from '../ListItem';
import { navigationDrawerContentDestinationItemStyles, navigationDrawerContentDestinationStyles, } from './NavigationDrawerContentDestination.styles';
import { navigationDrawerContentDestinationTheme } from './NavigationDrawerContentDestination.stylex';
export const NavigationDrawerContentDestination = forwardRef(function NavigationDrawerContentDestination(props, forwardedRef) {
    const { styles, sx, innerStyles, children, active, ...other } = props;
    const { combineStyles, globalStyles } = useStyles({
        name: 'NavigationDrawerContentDestination',
        styles: [navigationDrawerContentDestinationStyles, styles],
    });
    return (_jsx(ListItem, { ...other, sx: [
            navigationDrawerContentDestinationTheme,
            globalStyles,
            combineStyles('host'),
            sx,
        ], ref: forwardedRef, selected: active, innerStyles: {
            ...innerStyles,
            item: [
                navigationDrawerContentDestinationItemStyles,
                ...asArray(innerStyles?.item),
            ],
        }, children: children }));
});
